import { render, staticRenderFns } from "./OrderListcaowi.vue?vue&type=template&id=6a33f00f&scoped=true"
import script from "./OrderListcaowi.vue?vue&type=script&lang=js"
export * from "./OrderListcaowi.vue?vue&type=script&lang=js"
import style0 from "./OrderListcaowi.vue?vue&type=style&index=0&id=6a33f00f&prod&scoped=true&lang=css"
import style1 from "./OrderListcaowi.vue?vue&type=style&index=1&id=6a33f00f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33f00f",
  null
  
)

export default component.exports